import './productCodeSelector.scss';
import { IPromise } from 'angular';

interface Scope extends ng.IScope {
    keys: any[];
    selectedCodes: Array<{ name: string }>;
}

export class ProductCodeSelector implements ng.IComponentController {
    static instance = {
        controller: ['$scope', '$mdConstant', '$mdColors', ProductCodeSelector],
        template: require('./productCodeSelector.html'),
        bindings: {
            onValueChange: '=',
            fetchFunction: '<',
            class: '<'
        }
    };

    private $scope: Scope;
    private $mdColors: angular.material.IColorService;
    private onValueChange: (codes: string[]) => void;
    private fetchFunction: (query: string) => IPromise<string[]>;

    constructor($scope, $mdConstant, $mdColors: angular.material.IColorService) {
        this.$scope = $scope;
        this.$mdColors = $mdColors;

        $scope.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        $scope.selectedCodes = [];
    }

    $onInit = () => {
        this.$scope.$watchCollection('selectedCodes', this.emitCodes);
    };

    searchCodes = (q: string): IPromise<Array<{ name: string }>> =>
        this.fetchFunction(q).then((codes) => codes.map((c) => ({ name: c })));

    private emitCodes = () => {
        const codes = (this.$scope.selectedCodes || []).map((c) => c.name);
        this.onValueChange && this.onValueChange(codes);
    };

    $postLink(): void {
        setTimeout(() => {
            const input: HTMLInputElement =
                document.querySelector('.product-code-selector .md-chip-input-container input');
            const chipsEl: HTMLElement =
                document.querySelector('.product-code-selector md-chips .md-chips');
            const color = this.$mdColors.getThemeColor('default-primary-200');
            if (input && chipsEl) {
                input.onfocus = () => (chipsEl.style.boxShadow = `0 2px ${color}`);
                input.onblur  = () => (chipsEl.style.boxShadow = '0 1px rgba(255,255,255,0.12)');
            }
        }, 0);
    }
}
